<template>
  <div>
    <!-- <div class="chat-open-say" v-if="imgShow">
      <img src="../../assets/001.png" alt="" />
      <div style="position: relative">
        <div class="what">{{ $i18.language('欢迎来到小易的世界～') }}</div>
      </div>
    </div> -->
    <div  @click="openChat" @mousedown="move" class="chat-open">
      <!-- <img  style="width:70px" src="../../assets/xiaoyi.gif" alt="" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'chatImg',
  computed: {},
  data() {
    return {
      imgShow: true,
      monitorUser: '',
    }
  },
  mounted() {
    this.testTimeOut()
  },
  methods: {
    testTimeOut() {
      this.monitorUser = setTimeout(() => {
        this.imgShow = false
        clearTimeout(this.monitorUser)
      }, 5000)
    },
    openChat() {
      this.$emit('openChat')
    },
    move(e) {
      let odiv = e.target
      //算出鼠标相对元素的位置
      let disY = e.clientY - odiv.offsetTop
     ;(document.onmousemove = (e) => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let top = e.clientY - disY
        //移动当前元素
        
        if (top >= 0 && top <=  document.documentElement.clientHeight-80) {
          odiv.style.top = top + 'px'
        }
      }),
        (document.onmouseup = (e) => {
          document.onmousemove = null
          document.onmouseup = null
        })
    },
    
  },
}
</script>

<style lang="scss" scoped>
.what {
  padding: 10px 13px;
  width: 120px;
  font-size: 12px;
  font-weight: 400;
  color: #3d3d3d;
  display: inline-block;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  background: #fff;
  border-radius: 3px;
  position: absolute;
  top: -112px;
  left: -125px;
}
.chat-open {
  position: fixed;
  right: -3px;
  top: 65vh;
  cursor: pointer;
  z-index: 999;
  display: inline-block;
  background: url("../../assets/xiaoyi.gif") center top no-repeat;
  background-size:100%;
  width: 48px;
  height: 104.3px;
}
.chat-open-say {
  position: fixed;
  right: 300px;
  top: 70vh;
  cursor: pointer;
  z-index: 2000;
}
@keyframes myfirst {
  0% {
    top: 40vh;
  }
  25% {
    top: 50vh;
  }
  50% {
    top: 60vh;
  }
  75% {
    top: 40vh;
  }
  100% {
    top: 30vh;
  }
}
@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {
    top: 40vh;
  }
  25% {
    top: 50vh;
  }
  50% {
    top: 60vh;
  }
  75% {
    top: 50vh;
  }
  100% {
    top: 40vh;
  }
}
</style>